
const rows = [
  { volume: "2.35", label: "Break Even", revenue: "£70,500", costs: "£32,430", profit: "£0", margin: "0%", highlight: false },
  { volume: "8", label: "Efficient", revenue: "£240,000", costs: "£110,400", profit: "£91,600", margin: "38.2%", highlight: false },
  { volume: "15", label: "Target", revenue: "£450,000", costs: "£207,000", profit: "£205,000", margin: "45.6%", highlight: true },
  { volume: "18", label: "Max Capacity", revenue: "£540,000", costs: "£248,400", profit: "£253,600", margin: "47.0%", highlight: false },
];

const assumptions = [
  "£2,500 average fee per case",
  "£400 customer acquisition cost (CAC)",
  "Advisor: £30K base + 30% performance split",
  "£8K operational support cost per advisor",
];

export function UnitEconomicsSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          Strong margins emerge as advisor<br />productivity increases
        </h2>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mb-4">
        <table className="w-full border-collapse text-[12px]">
          <thead>
            <tr className="bg-[#818cf8] text-white text-[11px]">
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Volume (Cases/Mo)</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Annual Revenue</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Variable Costs (CAC + Comm)</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Annual Profit</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Net Margin</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr
                key={r.volume}
                className={`border-b border-[var(--color-border)] ${r.highlight ? "bg-[var(--color-surface)] font-medium" : "text-[var(--color-fg-secondary)]"}`}
              >
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>
                  {r.volume} ({r.label})
                </td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>{r.revenue}</td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>{r.costs}</td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold text-[#4533f7]" : ""}`}>{r.profit}</td>
                <td className={`py-2 px-3 font-bold ${r.highlight ? "text-[#4533f7]" : ""}`}>{r.margin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Key Assumptions */}
      <div className="mb-4">
        <div className="text-[12px] font-bold text-[var(--color-accent)] mb-2">
          Key Assumptions
        </div>
        <ul className="flex flex-wrap gap-x-6 gap-y-1">
          {assumptions.map((a) => (
            <li key={a} className="flex items-center gap-2 text-[12px] text-[var(--color-fg-secondary)]">
              <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] shrink-0" />
              {a}
            </li>
          ))}
        </ul>
      </div>

      {/* Summary */}
      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] leading-relaxed text-[var(--color-fg-secondary)]">
          <strong className="text-[var(--color-fg)] font-medium">At target capacity:</strong> each advisor generates £205K annual profit at 45.6% margin. This is the unit we replicate across acquired firms.
        </p>
      </div>
    </div>
  );
}
